import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

import DefaultInput from "../../../../../../common/components/default_input";
import CascateList from "../../../../../../common/components/cascate_list";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";

/**
 * Header Centro Custo Lista.
 * 
 */

type Props = {
  codigo: string,
  ddlCentroCusto: CentroCustoDropDown[];
  selectedIdsCentroCusto?: number[];
  status: number,
  handleIdCentroCustoChange: (v: number[]) => void;
  onCodigoChange: (codigo: string) => void,
  onStatusChange: (novoStatus: number) => void,
  onClearFilters: () => void,

};


export const Header = ({
  codigo,
  ddlCentroCusto,
  selectedIdsCentroCusto,
  status,
  handleIdCentroCustoChange,
  onCodigoChange,
  onStatusChange,
  onClearFilters,

}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
    onStatusChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [onStatusChange]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row-dense">
            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <div className="w-full">
                <DefaultInput
                  label="Código"
                  name="search_by_código_centro_custo"
                  value={codigo}
                  onChangeValue={onCodigoChange} />
              </div>

              <div className="w-full">

                <DefaultMultiAutocomplete
                  label='Centro de Custo'
                  value={ddlCentroCusto.filter(x => selectedIdsCentroCusto?.includes(x.id))}
                  options={ddlCentroCusto}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdCentroCustoChange(x?.map(y => y.id) ?? [])} />
              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-1 gap-1">
              <FormControl size="small" fullWidth>
                <InputLabel id="modulo-dashboard"></InputLabel>
                <Select
                  labelId="modulo-dashboard"
                  label=""
                  value={status}
                  onChange={handleStatusChange}>
                  <MenuItem value={3}>Todos</MenuItem>
                  <MenuItem value={0}>Ativos</MenuItem>
                  <MenuItem value={1}>Bloqueados</MenuItem>
                  <MenuItem value={2}>Encerrados</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}